__turbopack_context__.v({
  "DkShow": "style-module__D5xijW__DkShow",
  "MobileShow": "style-module__D5xijW__MobileShow",
  "bannerOuter": "style-module__D5xijW__bannerOuter",
  "bannerSec": "style-module__D5xijW__bannerSec",
  "commonBtnGetapp": "style-module__D5xijW__commonBtnGetapp",
  "getApp": "style-module__D5xijW__getApp",
  "getAppScanner": "style-module__D5xijW__getAppScanner",
  "getappMain": "style-module__D5xijW__getappMain",
});
